import * as Sentry from '@sentry/react'
import type { ReceiverEvent } from './device-requests/source'

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0'),
    integrations: [Sentry.browserTracingIntegration()],
  })
}

export function setDisplayContext(placeId: string, userId: string): void {
  Sentry.setTag('place_id', placeId)
  Sentry.setTag('user_id', userId)
}

/** What the device-request connection went through. Every event is a
 *  breadcrumb, so a crash report shows the connection's story. Only two are
 *  reports of their own: a refusal, which leaves a blank screen until the till
 *  pairs again, and a fifth reconnect in a row, which means the display has
 *  been cut off for a while. The grant itself is never passed in. */
export function reportReceiverEvent(event: ReceiverEvent): void {
  Sentry.addBreadcrumb({ category: 'cfd.receiver', level: 'info', data: { ...event } })

  if (event.kind === 'refused') {
    Sentry.captureMessage(`CFD receiver refused: ${event.reason}`, {
      level: 'warning',
      tags: { 'cfd.refusal': event.reason, 'cfd.code': String(event.code ?? '') },
    })
  } else if (event.kind === 'reconnecting' && event.failures === 5) {
    Sentry.captureMessage('CFD receiver cannot reach the API', {
      level: 'warning',
      tags: { 'cfd.code': String(event.code ?? '') },
    })
  }
}
